module.exports = require('./helpers/bundle-url').getBundleURL('4zqgQ') + "logo.c51670a8.svg";